import { render } from "./cpt-richtxt-option.vue?vue&type=template&id=c48b5b10"
import script from "./cpt-richtxt-option.vue?vue&type=script&lang=js"
export * from "./cpt-richtxt-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__